import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Router, NavigationEnd } from '@angular/router';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
/**
 * Service to control what buttons are shown in Content Header Bars
 *
 * @export
 * @class ContentHeaderBarService
 */
export class ContentHeaderBarService {
    constructor(router) {
        this.router = router;
        /**
         * Emits when a button is clicked
         *
         * @memberof ContentHeaderBarService
         */
        this.onClick = new Subject();
        /**
         * The list of buttons to show
         *
         * @type {ContentHeaderButton[]}
         * @memberof ContentHeaderBarService
         */
        this.buttons = [];
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.clearButtons();
            }
        });
    }
    /**
     * Adds buttons. Default is on the right (end)
     *
     * @param {ContentHeaderButton[]} [buttons=[]]
     * @param {boolean} [onLeft=false]
     * @memberof ContentHeaderBarService
     */
    setButtons(buttons = [], onLeft = false) {
        // Is this promise needed? https://stackoverflow.com/a/45113158
        Promise.resolve().then(() => {
            this.clearButtons();
            if (onLeft) {
                this.buttons.unshift(...buttons);
            }
            else {
                this.buttons.push(...buttons);
            }
        });
    }
    /**
     * Removes all buttons
     *
     * @memberof ContentHeaderBarService
     */
    clearButtons() {
        this.buttons.splice(0, this.buttons.length);
    }
    static { this.ɵfac = function ContentHeaderBarService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ContentHeaderBarService)(i0.ɵɵinject(i1.Router)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ContentHeaderBarService, factory: ContentHeaderBarService.ɵfac }); }
}
//# sourceMappingURL=content-header-bar.service.js.map